import { CUSTOM_VIEW_GROUPS } from 'src/graphql/entities/custom-view/constants';
import { mapServiceLevelFilter } from 'src/graphql/entities/custom-view/custom-view-config/service-level-filter';
import {
  CustomViewFormConditionCustomData,
  CustomViewFormConditionField,
  UIType,
} from 'src/graphql/entities/custom-view/custom-view.types';
import { UserGroupRules } from 'src/graphql/entities/group-rules/group-rules.types';
import { ConditionInput, EntityNames } from 'src/graphql/types';
import { SupportedActionQueries } from 'src/pages/Settings/rules/use-rules-engine';
import {
  ProjectAttribute,
  ProjectAttributeAccessors,
  ProjectAttributeType,
} from './constants';
import { projectAttributeConfigMap } from './displaying';

export const projectFilterAttributesList = [
  projectAttributeConfigMap.get(ProjectAttribute.name)!,
  {
    ...projectAttributeConfigMap.get(ProjectAttribute.stage)!,
    uiType: UIType.List,
    optionsQuery: SupportedActionQueries.getProjectStage,
  },
  projectAttributeConfigMap.get(ProjectAttribute.estSigningDate)!,
  projectAttributeConfigMap.get(ProjectAttribute.estDay1)!,
  projectAttributeConfigMap.get(ProjectAttribute.day1StartDate)!,
  projectAttributeConfigMap.get(ProjectAttribute.warrantyExpiration)!,
  projectAttributeConfigMap.get(ProjectAttribute.cppExpDate)!,
  {
    ...projectAttributeConfigMap.get(ProjectAttribute.projectManager)!,
    uiType: UIType.List,
    pluralLabel: 'project managers',
    optionsQuery: SupportedActionQueries.getPlatformUser,
  },

  projectAttributeConfigMap.get(ProjectAttribute.siteCity)!,
  projectAttributeConfigMap.get(ProjectAttribute.siteZip)!,
  {
    ...projectAttributeConfigMap.get(ProjectAttribute.siteClientSegment)!,
    pluralLabel: 'client segments',
    uiType: UIType.List,
    attributeLabel: 'Client Segment',
    optionsQuery: SupportedActionQueries.getBrand,
  },
  projectAttributeConfigMap.get(ProjectAttribute.siteCreatedAt)!,
  projectAttributeConfigMap.get(ProjectAttribute.siteUpdatedAt)!,
  projectAttributeConfigMap.get(ProjectAttribute.siteTOS)!,
  {
    ...projectAttributeConfigMap.get(ProjectAttribute.siteTOS)!,
    uiType: UIType.List,
    optionsQuery: SupportedActionQueries.getBooleanOptions,
  },
  {
    ...projectAttributeConfigMap.get(ProjectAttribute.siteMembershipRegistered)!,
    uiType: UIType.List,
    optionsQuery: SupportedActionQueries.getBooleanOptions,
  },
  {
    ...projectAttributeConfigMap.get(ProjectAttribute.clientActivatedMembership)!,
    uiType: UIType.List,
    optionsQuery: SupportedActionQueries.getServiceLevelIdOptions,
  },
  projectAttributeConfigMap.get(ProjectAttribute.partnerName)!,

  projectAttributeConfigMap.get(ProjectAttribute.id)!,
  projectAttributeConfigMap.get(ProjectAttribute.createdAt)!,
  projectAttributeConfigMap.get(ProjectAttribute.updatedAt)!,
  {
    attribute: ProjectAttribute.deleted,
    attributeLabel: 'Deleted',
    uiType: UIType.Flag,
    group: CUSTOM_VIEW_GROUPS.Project,
    options: [],
    allowedRules: [UserGroupRules.AccessToRestoreDeletedProjects],
    queryParams: { includeDeleted: true },
  },
].map((i) => ({
  ...i,
  accessor: ProjectAttributeAccessors[i.attribute].filter,
  rootEntity: EntityNames.Project as const,
  value: i.attribute,
  label: i.attributeLabel,
  options: i.options ?? [],
  fieldOptions: i.options ?? [],
}));

export const projectFilterAttributesMap = new Map<
  ProjectAttributeType,
  CustomViewFormConditionField
>(projectFilterAttributesList.map((i) => [i.attribute, i]));

export const PROJECT_FILTER_MAPPER: Record<
  string,
  (data: CustomViewFormConditionCustomData) => ConditionInput | ConditionInput[]
> = {
  [ProjectAttributeAccessors[ProjectAttribute.clientActivatedMembership].filter]: (
    data: CustomViewFormConditionCustomData,
  ) =>
    mapServiceLevelFilter(
      data,
      ProjectAttributeAccessors[ProjectAttribute.clientActivatedMembership].filter,
      ProjectAttributeAccessors[ProjectAttribute.cppExpDate].filter,
    ),
};
